module.exports = "<div id='occIframeHolder' hidden=true #occIframeHolder></div>"